import { PacksClient } from '../types'
import { SearchPacksResponse } from '../types/PacksClient'

export const searchPacks = (base: PacksClient) => (search: string) =>
  base.requester.post<SearchPacksResponse>('/search', { search }, { withCredentials: true })
